<template>
    <v-dialog persistent v-model="dialog" max-width="500">
        <v-card>
            <v-card-title class="bg-yellow-darken-4 d-flex justify-space-between pa-4">
                <span class="title text-white pl-2">
                    <i class="fa-duotone fa-list-ul mr-2"></i>
                    {{ title }}
                </span>
                <v-icon @click="rejectDialog">mdi-close</v-icon>
            </v-card-title>
            <v-divider></v-divider>
            <perfect-scrollbar>
                <v-card-text>
                    <sm-text-field label="Remark" v-model="remark" />

                </v-card-text>
            </perfect-scrollbar>
            <v-divider></v-divider>
            <v-card-actions class="pa-4">
                <v-btn prepend-icon="mdi-close" color="error" variant="tonal" @click="rejectDialog">Close</v-btn>
                <v-spacer></v-spacer>
                <v-btn prepend-icon="mdi-check" @click="saveChange" color="secondary" variant="flat">{{ label }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import { ref } from 'vue';
    import swal from 'sweetalert2'
    export default {
        props: {
            modelValue: null,
            label: {
                type: String,
                default: 'Save',
            },
            title: {
                type: String,
                default: 'Please enter your remark',
            },
        },
        data() {
            return {
                dialog: false,
                remark: null,
                resolve: null,
                reject: null,
            };
        },
        methods: {
            closeDialog() {
                this.dialog = false;
                if (this.resolve) {
                    this.resolve(null); // Resolve with null if closed
                    this.resolve = null; // Clear resolve function
                }
            },
            rejectDialog() {
                this.dialog = false;
                if (this.reject) {
                    //this.reject(new Error('Dialog closed without saving')); // Reject the promise
                    this.reject(); // Reject the promise
                    this.reject = null; // Clear reject function
                    swal.fire({
                        position: 'top-right',
                        toast: true,
                        icon: 'error',
                        title: 'Action Cancel',
                        timer: 1000,
                        timerProgressBar: true,
                        showConfirmButton: false,
                    });
                    return;
                }
            },
            showDialog() {
                return new Promise((resolve, reject) => {
                    this.dialog = true;
                    this.resolve = resolve; // Store the resolve function
                    this.reject = reject; // Store the reject function
                });
            },
            saveChange() {
                this.dialog = false;
                if (this.resolve) {
                    this.resolve(this.remark); // Resolve with the remark value
                    this.resolve = null; // Clear resolve function
                }
            },
        },
    };
</script>
